export default "__VITE_ASSET__DFpSzb8i__"